var map = {
	"./ion-action-sheet.entry.js": [
		9052,
		9052
	],
	"./ion-alert.entry.js": [
		52,
		52
	],
	"./ion-app_8.entry.js": [
		6886,
		6886
	],
	"./ion-avatar_3.entry.js": [
		5135,
		5135
	],
	"./ion-back-button.entry.js": [
		5684,
		5684
	],
	"./ion-backdrop.entry.js": [
		194,
		194
	],
	"./ion-button_2.entry.js": [
		9417,
		9417
	],
	"./ion-card_5.entry.js": [
		6090,
		6090
	],
	"./ion-checkbox.entry.js": [
		1401,
		1401
	],
	"./ion-chip.entry.js": [
		7866,
		7866
	],
	"./ion-col_3.entry.js": [
		2062,
		2062
	],
	"./ion-datetime_3.entry.js": [
		4795,
		4795
	],
	"./ion-fab_3.entry.js": [
		3809,
		3809
	],
	"./ion-img.entry.js": [
		6765,
		6765
	],
	"./ion-infinite-scroll_2.entry.js": [
		1097,
		1097
	],
	"./ion-input.entry.js": [
		2318,
		2318
	],
	"./ion-item-option_3.entry.js": [
		8267,
		8267
	],
	"./ion-item_8.entry.js": [
		6919,
		9300
	],
	"./ion-loading.entry.js": [
		706,
		706
	],
	"./ion-menu_3.entry.js": [
		7101,
		7101
	],
	"./ion-modal.entry.js": [
		8327,
		8327
	],
	"./ion-nav_2.entry.js": [
		6298,
		6298
	],
	"./ion-popover.entry.js": [
		8347,
		8347
	],
	"./ion-progress-bar.entry.js": [
		9623,
		9623
	],
	"./ion-radio_2.entry.js": [
		9364,
		9364
	],
	"./ion-range.entry.js": [
		5043,
		5043
	],
	"./ion-refresher_2.entry.js": [
		4403,
		4403
	],
	"./ion-reorder_2.entry.js": [
		6840,
		6840
	],
	"./ion-ripple-effect.entry.js": [
		2278,
		2278
	],
	"./ion-route_4.entry.js": [
		5592,
		5592
	],
	"./ion-searchbar.entry.js": [
		959,
		959
	],
	"./ion-segment_2.entry.js": [
		878,
		878
	],
	"./ion-select_3.entry.js": [
		458,
		458
	],
	"./ion-slide_2.entry.js": [
		3358,
		3358
	],
	"./ion-spinner.entry.js": [
		4831,
		4831
	],
	"./ion-split-pane.entry.js": [
		2445,
		2445
	],
	"./ion-tab-bar_2.entry.js": [
		1452,
		1452
	],
	"./ion-tab_2.entry.js": [
		1468,
		1468
	],
	"./ion-text.entry.js": [
		9175,
		9175
	],
	"./ion-textarea.entry.js": [
		7758,
		7758
	],
	"./ion-toast.entry.js": [
		6385,
		6385
	],
	"./ion-toggle.entry.js": [
		9848,
		9848
	],
	"./ion-virtual-scroll.entry.js": [
		7803,
		7803
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5435;
module.exports = webpackAsyncContext;